import { boolean, number, object, string, date } from 'yup';

// Any plausible web link passes — Google Meet, Zoom, Teams or anything
// else. Scheme optional (the student portal prepends https:// on join).
// Mirrors WebinarService.assertMeetingUrl on the backend.
const isMeetingUrl = (value?: string | null) => {
	if (!value || /\s/.test(value.trim())) return false;
	try {
		const url = new URL(
			/^https?:\/\//i.test(value) ? value : `https://${value}`
		);
		return /^https?:$/.test(url.protocol) && url.hostname.includes('.');
	} catch {
		return false;
	}
};

export const ADD_SLOT = object({
	start_time: date()
		.typeError('Invalid Date')
		.required('Start Date & Time is required'),
	end_time: string(),
	duration: number().min(1).required(),
	description: string().required(),
	name: string().required(),
	unlimited: boolean(),
	provider: string().oneOf(['bbb', 'external']).required(),
	capacity: number()
		.nullable(true)
		.transform((v, o) => {
			return isNaN(o) ? '' : v;
		})
		.when('unlimited', {
			is: false,
			then: number()
				.typeError('Capacity Must be a number')
				.moreThan(0, 'Capacity must be bigger than zero')
				.required(),
		}),
	slot_url: string()
		.when('provider', {
			is: 'bbb',
			then: string().nullable(true),
			otherwise: string()
				.required('Slot URL is required')
				.test(
					'meeting-url',
					'Enter a valid meeting link (Google Meet, Zoom, Microsoft Teams…)',
					isMeetingUrl
				),
		})
});
